module.exports = __webpack_public_path__ + "static/media/SBDO.9d2273cf.png";